import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

var chatMessagesService;

export default function () {
	var ChatMessagesModel = Model.extend({
		className: "ChatMessages",
		defaults: {}
	});
	
	var ChatMessagesCollection = Collection.extend({
		model: ChatMessagesModel
	});
	
	var ChatMessagesService = ParseService.extend({
		sortBy: 'createdAt',
		order: 'dsc',
		model: ChatMessagesModel,
		collection: ChatMessagesCollection,
		setChatMessage:function(targetUser, message, file, done, err){
			var sender = { __type: 'Pointer', className: '_User', objectId: Parse.User.current().id };
			var receiver = { __type: 'Pointer', className: '_User', objectId: targetUser };
			var ChatMessage = Parse.Object.extend("ChatMessages");
			var chatMessage = new ChatMessage();
			if(message !== undefined && message.trim() === ''){
				return;
			}
			chatMessage.set("sender",sender);
			chatMessage.set("receiver",receiver);
			chatMessage.set("message",message);
			chatMessage.set("file",file);
			chatMessage.set("read",false);
			chatMessage.save(null, {
				success: function(chatMessage) {
					done(chatMessage);
				},
				error: function(chatMessage, error) {
					err(error);
				}
			});
		},
		
		getConversation: function(targetUser, skip, limit){
			var sender = { __type: 'Pointer', className: '_User', objectId: Parse.User.current().id };
			var receiver = { __type: 'Pointer', className: '_User', objectId: targetUser };
			var query1 = new Parse.Query('ChatMessages');
			query1.equalTo('receiver', receiver);
			query1.equalTo('sender', sender);
			var query2 = new Parse.Query('ChatMessages');
			query2.equalTo('receiver', sender);
			query2.equalTo('sender', receiver);
			var mainQuery = Parse.Query.or(query1, query2);
			mainQuery.select('message', 'file', 'read', 'sender');
			mainQuery.descending("createdAt");
			mainQuery.skip(skip * limit);
			mainQuery.limit(limit);
			return mainQuery.find();
		},
		
		setMessagesAsRead: function(targetUser) {
			var sender = { __type: 'Pointer', className: '_User', objectId: targetUser};
			var receiver = { __type: 'Pointer', className: '_User', objectId: Parse.User.current().id };
			var query = new Parse.Query('ChatMessages');
			query.equalTo('receiver', receiver);
			query.equalTo('sender', sender);
			query.equalTo('read', false);
			query.select('read');
			query.find().then(function(results) {
				for(var i=0; i < results.length; i++){
					results[i].set('read', true);
				}
				Parse.Object.saveAll(results).then((list) => {
					
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			});
		},
		
		setFileMessages: function(targetUser, files, error, done){
			var sender = { __type: 'Pointer', className: '_User', objectId: Parse.User.current().id };
			var receiver = { __type: 'Pointer', className: '_User', objectId: targetUser };
			var ChatMessage = Parse.Object.extend("ChatMessages");
			var chatMessages = [];
			for(var i=0; i < files.length; i++){
				var item = new ChatMessage();
				item.set("sender",sender);
				item.set("receiver",receiver);
				item.set("message",undefined);
				item.set("file",files[i]);
				item.set("read",false);
				chatMessages.push(item);
			}
			Parse.Object.saveAll(chatMessages).then((list) => {
				done(list);
			},
			(err) => {
				error(err);
			});
		}
	});
	return chatMessagesService || (chatMessagesService = new ChatMessagesService());
};
